import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FicheJoueurSimpleComponent = _resolveComponent("FicheJoueurSimpleComponent")!
  const _component_FicheJoueurCaracteristiquesComponent = _resolveComponent("FicheJoueurCaracteristiquesComponent")!
  const _component_v_responsive = _resolveComponent("v-responsive")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "fill-height" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_responsive, {
        class: "align-top mx-auto",
        "max-width": "800"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_FicheJoueurSimpleComponent, {
            fiche: _ctx.ficheJoueurData,
            model: _ctx.ficheJoueurModel,
            section: 'infosGenerales'
          }, null, 8, ["fiche", "model"]),
          _createVNode(_component_FicheJoueurCaracteristiquesComponent, {
            fiche: _ctx.ficheJoueurData,
            model: _ctx.ficheJoueurModel,
            section: 'caracteristiquesPrincipales'
          }, null, 8, ["fiche", "model"]),
          _createVNode(_component_FicheJoueurCaracteristiquesComponent, {
            fiche: _ctx.ficheJoueurData,
            model: _ctx.ficheJoueurModel,
            section: 'caracteristiquesSecondaires'
          }, null, 8, ["fiche", "model"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}